import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProductAttributeByGroup } from 'src/app/models/company-shoes.model';

@Component({
  selector: 'app-product-attributes',
  imports: [CommonModule],
  templateUrl: './product-attributes.component.html',
  styleUrl: './product-attributes.component.scss',
})
export class ProductAttributesComponent {
  @Input('attributes') attributes: ProductAttributeByGroup | undefined;
  @Input('titleClass') titleClass: string = '';

  get hasAttributes(): boolean {
    return !!this.attributes && Object.keys(this.attributes).length > 0;
  }
}
